export enum InternalHistoryEntryType {
  INVOICE_CREATED = 'INVOICE_CREATED',
  INVOICE_ATTACHMENT = 'INVOICE_ATTACHMENT',
  INVOICE_FINALISED = 'INVOICE_FINALISED',
  INVOICE_UPDATED = 'INVOICE_UPDATED',
  INVOICE_CANCELLED = 'INVOICE_CANCELLED',
  INVOICE_CREDITED = 'INVOICE_CREDITED',
  INVOICE_PAYMENT = 'INVOICE_PAYMENT',
  INVOICE_PAYMENT_REFUNDED = 'INVOICE_PAYMENT_REFUNDED',
  CREDIT_USED = 'CREDIT_USED',
  CREDIT_MATCHED = 'CREDIT_MATCHED',
  CREDIT_USED_FROM_CREDITING_INVOICE = 'CREDIT_USED_FROM_CREDITING_INVOICE',
  INVOICE_DISTRIBUTED = 'INVOICE_DISTRIBUTED',
  INVOICE_DISTRIBUTION_FAILED = 'INVOICE_DISTRIBUTION_FAILED',
  INVOICE_REMINDER = 'INVOICE_REMINDER',
  INVOICE_REMINDER_FEE_CANCELLED = 'INVOICE_REMINDER_FEE_CANCELLED',
  INVOICE_DEBT_COLLECTION = 'INVOICE_DEBT_COLLECTION',
}
